<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div>
                    <div class="page-block__overview-link">
                        <customer-router-link :to="{ name: 'customers' }" class="link-no-decoration | u-flex-center">
                            <svg width="16" viewBox="0 0 32 32" class="u-margin-right-inline">
                                <use xlink:href="@/assets/arrow.svg#arrow-left"></use>
                            </svg>
                            <strong>{{ trans('page.customers.back-to') }}</strong>
                        </customer-router-link>
                    </div>

                    <h1 class="page-block__title | u-font-weight-normal">{{ trans('page.customer-create.title') }}</h1>
                </div>

                <div class="page-block">
                    <create-customer :form="form" :countries="countries" @submit="createCustomer" class="select-gray" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { customerMixin, CreateCustomer, CustomersApi } from 'relapp-customers';
import { Api, apiMixin } from 'relapp-api';
import { EventBus } from 'relapp-event';
import { Way2Form, formMixin } from 'relapp-way2forms';
import { canHaveCustomersPageMixin } from 'relapp-auth';

export default {
    components: {
        CreateCustomer
    },
    metaInfo: {
        title: trans('page.customers.title')
    },
    mixins: [apiMixin, customerMixin, formMixin, canHaveCustomersPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                first_name: null,
                last_name: null,
                organization: null,
                department: null,
                email: null,
                phone_number: null,
                street_name: null,
                street_number: null,
                zip_code: null,
                city: null,
                country_code: 'NL',
                create_user: false
            }),
            countries: {}
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        Api.get('/countries/nl.json').then(response => {
            this.countries = response.data;
        });
    },
    methods: {
        /**
         * Call the endpoint to create the customer.
         *
         * @param {object} form
         */
        createCustomer(form) {
            this.startLoading();
            CustomersApi.add(form.data())
                .then(() => {
                    this.$router.push({ name: 'customers' });

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('customer.confirmation.message')
                    });
                })
                .catch(error => {
                    this.showValidationErrors(error, form);
                })
                .then(this.finishLoading);
        }
    }
};
</script>
